// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.8.3
//   protoc               v3.21.12
// source: submitcase.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import {
  CancerType,
  cancerTypeFromJSON,
  cancerTypeToJSON,
  Reasoning,
  reasoningFromJSON,
  reasoningToJSON,
  Verbosity,
  verbosityFromJSON,
  verbosityToJSON,
} from "./schema";

export const protobufPackage = "login";

export interface FileUpload {
  filename: string;
  content: Uint8Array;
}

export interface SubmitCaseRequest {
  caseJson?: string | undefined;
  cancerType?: CancerType | undefined;
  files: FileUpload[];
  isStaging?: boolean | undefined;
  verbosity?: Verbosity | undefined;
  reasoning?: Reasoning | undefined;
}

export interface SubmitCaseResponse {
  caseId: string;
}

function createBaseFileUpload(): FileUpload {
  return { filename: "", content: new Uint8Array(0) };
}

export const FileUpload: MessageFns<FileUpload> = {
  encode(message: FileUpload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.filename !== "") {
      writer.uint32(10).string(message.filename);
    }
    if (message.content.length !== 0) {
      writer.uint32(18).bytes(message.content);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FileUpload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFileUpload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.filename = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.content = reader.bytes();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FileUpload {
    return {
      filename: isSet(object.filename) ? globalThis.String(object.filename) : "",
      content: isSet(object.content) ? bytesFromBase64(object.content) : new Uint8Array(0),
    };
  },

  toJSON(message: FileUpload): unknown {
    const obj: any = {};
    if (message.filename !== "") {
      obj.filename = message.filename;
    }
    if (message.content.length !== 0) {
      obj.content = base64FromBytes(message.content);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FileUpload>, I>>(base?: I): FileUpload {
    return FileUpload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FileUpload>, I>>(object: I): FileUpload {
    const message = createBaseFileUpload();
    message.filename = object.filename ?? "";
    message.content = object.content ?? new Uint8Array(0);
    return message;
  },
};

function createBaseSubmitCaseRequest(): SubmitCaseRequest {
  return {
    caseJson: undefined,
    cancerType: undefined,
    files: [],
    isStaging: undefined,
    verbosity: undefined,
    reasoning: undefined,
  };
}

export const SubmitCaseRequest: MessageFns<SubmitCaseRequest> = {
  encode(message: SubmitCaseRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.caseJson !== undefined) {
      writer.uint32(10).string(message.caseJson);
    }
    if (message.cancerType !== undefined) {
      writer.uint32(16).int32(message.cancerType);
    }
    for (const v of message.files) {
      FileUpload.encode(v!, writer.uint32(26).fork()).join();
    }
    if (message.isStaging !== undefined) {
      writer.uint32(32).bool(message.isStaging);
    }
    if (message.verbosity !== undefined) {
      writer.uint32(40).int32(message.verbosity);
    }
    if (message.reasoning !== undefined) {
      writer.uint32(48).int32(message.reasoning);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SubmitCaseRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSubmitCaseRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.caseJson = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.cancerType = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.files.push(FileUpload.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.isStaging = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.verbosity = reader.int32() as any;
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.reasoning = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SubmitCaseRequest {
    return {
      caseJson: isSet(object.caseJson) ? globalThis.String(object.caseJson) : undefined,
      cancerType: isSet(object.cancerType) ? cancerTypeFromJSON(object.cancerType) : undefined,
      files: globalThis.Array.isArray(object?.files) ? object.files.map((e: any) => FileUpload.fromJSON(e)) : [],
      isStaging: isSet(object.isStaging) ? globalThis.Boolean(object.isStaging) : undefined,
      verbosity: isSet(object.verbosity) ? verbosityFromJSON(object.verbosity) : undefined,
      reasoning: isSet(object.reasoning) ? reasoningFromJSON(object.reasoning) : undefined,
    };
  },

  toJSON(message: SubmitCaseRequest): unknown {
    const obj: any = {};
    if (message.caseJson !== undefined) {
      obj.caseJson = message.caseJson;
    }
    if (message.cancerType !== undefined) {
      obj.cancerType = cancerTypeToJSON(message.cancerType);
    }
    if (message.files?.length) {
      obj.files = message.files.map((e) => FileUpload.toJSON(e));
    }
    if (message.isStaging !== undefined) {
      obj.isStaging = message.isStaging;
    }
    if (message.verbosity !== undefined) {
      obj.verbosity = verbosityToJSON(message.verbosity);
    }
    if (message.reasoning !== undefined) {
      obj.reasoning = reasoningToJSON(message.reasoning);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SubmitCaseRequest>, I>>(base?: I): SubmitCaseRequest {
    return SubmitCaseRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SubmitCaseRequest>, I>>(object: I): SubmitCaseRequest {
    const message = createBaseSubmitCaseRequest();
    message.caseJson = object.caseJson ?? undefined;
    message.cancerType = object.cancerType ?? undefined;
    message.files = object.files?.map((e) => FileUpload.fromPartial(e)) || [];
    message.isStaging = object.isStaging ?? undefined;
    message.verbosity = object.verbosity ?? undefined;
    message.reasoning = object.reasoning ?? undefined;
    return message;
  },
};

function createBaseSubmitCaseResponse(): SubmitCaseResponse {
  return { caseId: "" };
}

export const SubmitCaseResponse: MessageFns<SubmitCaseResponse> = {
  encode(message: SubmitCaseResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.caseId !== "") {
      writer.uint32(10).string(message.caseId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SubmitCaseResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSubmitCaseResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.caseId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SubmitCaseResponse {
    return { caseId: isSet(object.caseId) ? globalThis.String(object.caseId) : "" };
  },

  toJSON(message: SubmitCaseResponse): unknown {
    const obj: any = {};
    if (message.caseId !== "") {
      obj.caseId = message.caseId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SubmitCaseResponse>, I>>(base?: I): SubmitCaseResponse {
    return SubmitCaseResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SubmitCaseResponse>, I>>(object: I): SubmitCaseResponse {
    const message = createBaseSubmitCaseResponse();
    message.caseId = object.caseId ?? "";
    return message;
  },
};

function bytesFromBase64(b64: string): Uint8Array {
  if ((globalThis as any).Buffer) {
    return Uint8Array.from(globalThis.Buffer.from(b64, "base64"));
  } else {
    const bin = globalThis.atob(b64);
    const arr = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; ++i) {
      arr[i] = bin.charCodeAt(i);
    }
    return arr;
  }
}

function base64FromBytes(arr: Uint8Array): string {
  if ((globalThis as any).Buffer) {
    return globalThis.Buffer.from(arr).toString("base64");
  } else {
    const bin: string[] = [];
    arr.forEach((byte) => {
      bin.push(globalThis.String.fromCharCode(byte));
    });
    return globalThis.btoa(bin.join(""));
  }
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
